import { useState } from 'react'

interface PasswordFieldProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  showError?: boolean
  errorMessage?: string
}

export default function PasswordField({
  value,
  onChange,
  placeholder = '8-16 characters, letters + numbers only',
  showError = false,
  errorMessage = 'Password error, please re-enter',
}: PasswordFieldProps) {
  const [visible, setVisible] = useState(false)

  return (
    <div className="form-item">
      <span className="label">Password</span>
      <div className="input-text-wrapper">
        <input
          className="input-text"
          type={visible ? 'text' : 'password'}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        <button
          type="button"
          className={`eye${visible ? ' eye-on' : ''}`}
          aria-label={visible ? 'Hide password' : 'Show password'}
          onClick={() => setVisible((v) => !v)}
        />
      </div>
      {showError && <p className="help">{errorMessage}</p>}
    </div>
  )
}
